import React, { useEffect, useMemo, useState, useRef } from 'react'
import { useGeralFilter } from '../../../context/FiltersContext/PeriodoFilter'
import api from '../../../services/axios'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import { CiCalendar } from 'react-icons/ci'
import { IoCloseCircleSharp } from 'react-icons/io5'
import { FaSearch, FaCheck } from 'react-icons/fa'
import { ItemContainerStyle } from './styles'
import { carregarDistribuidores } from '../../../services/dists'
import { useAuth } from '../../../context/AuthContext'

const monthNames = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

const BRAZILIAN_UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
]

interface modalProps {
  closeModal: () => void
  isMarketAnalysis?: boolean
}

interface Distributor {
  id?: string | number
  _id?: string | number
  name?: string
  fantasy_name?: string
  nome?: string
  razao_social?: string
}

export default function GeralFilterBar({ closeModal, isMarketAnalysis }: modalProps) {
  const { user } = useAuth()
  const {
    year,
    setYear,
    compareYear,
    setCompareYear,
    month,
    setMonth,
    compareMonth,
    setCompareMonth,
    endMonth,
    setEndMonth,
    visao,
    setVisao,
    semanas,
    toggleSemana,
    selectAllSemanas,
    trimestres,
    toggleTrimestre,
    selectAllTrimestres,
    setDistributor,
    distributorIds,
    setDistributorIds,
    toggleDistributor,
    selectAllDistributors,
    clearDistributors,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    operacao,
    setOperacao,
    gestor,
    setGestor,
    marca,
    setMarca,
    categoria,
    setCategoria,
    uf,
    setUf,
    mesesAno,
    setMesesAno,
  } = useGeralFilter()

  const [tempMesesAno, setTempMesesAno] = useState<number[]>(
    Array.isArray(mesesAno) && mesesAno.length > 0
      ? mesesAno
      : [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  )

  useEffect(() => {
    if (Array.isArray(mesesAno)) {
      setTempMesesAno(mesesAno)
    }
  }, [mesesAno])

  const toggleTempMesAno = (mIdx: number) => {
    setTempMesesAno((prev) => {
      if (prev.includes(mIdx)) {
        return prev.filter((m) => m !== mIdx).sort((a, b) => a - b)
      } else {
        return [...prev, mIdx].sort((a, b) => a - b)
      }
    })
  }

  const selectAllTempMesesAno = () => {
    setTempMesesAno([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11])
  }

  const clearTempMesesAno = () => {
    setTempMesesAno([])
  }

  const [distributors, setDistributors] = useState<Distributor[]>([])
  const [distSearch, setDistSearch] = useState('')
  const [showCalendar, setShowCalendar] = useState(false)
  const [operacoesList, setOperacoesList] = useState<any[]>([])
  const [ufsList, setUfsList] = useState<string[]>(BRAZILIAN_UFS)
  const [gestoresList, setGestoresList] = useState<any[]>([])
  const [marcasList, setMarcasList] = useState<any[]>([])
  const [categoriasList, setCategoriasList] = useState<any[]>([])
  const calendarRef = useRef<HTMLDivElement>(null)
  const [userMarca, setUserMarca] = useState('')

  const filteredDistributorsList = useMemo(() => {
    const term = distSearch.trim().toLowerCase()
    return distributors.filter((d: any) => {
      const name = d.fantasy_name || d.name || d.nome || d.razao_social || ''
      const cod = d.cod_dist || d.id || ''
      const matchesSearch = !term || name.toLowerCase().includes(term) || String(cod).toLowerCase().includes(term)

      const reg = (d.regional || d.operacao || d.regiao || '').trim().toLowerCase()
      const matchesOperacao = !operacao || reg === operacao.trim().toLowerCase()

      const matchesGestor = !gestor || (d.gestor_id && String(d.gestor_id) === String(gestor))

      const distUf = String(d.uf || d.estado || '').trim().toUpperCase()
      const matchesUf = !uf || !distUf || distUf === uf.trim().toUpperCase()

      return matchesSearch && matchesOperacao && matchesGestor && matchesUf
    })
  }, [distributors, distSearch, operacao, gestor, uf])

  useEffect(() => {
    const initData = async () => {
      try {
        const userVinculoMarca = user?.vinc_marca ? String(user.vinc_marca) : ''
        setUserMarca(userVinculoMarca)

        let dists: any[] = []

        dists = await carregarDistribuidores()
        setDistributors(dists)

        const operacoesUnicas = Array.from(
          new Set(dists.map((d: any) => d.regional || d.operacao || d.regiao).filter(Boolean)),
        )
        setOperacoesList(operacoesUnicas)

        const distUfs = Array.from(
          new Set(
            dists
              .map((d: any) => String(d.uf || d.estado || '').trim().toUpperCase())
              .filter((u: string) => u.length === 2 && u !== 'N/'),
          ),
        )
        const mergedUfs = Array.from(new Set([...distUfs, ...BRAZILIAN_UFS])).sort()
        setUfsList(mergedUfs)

        const [prodRes, getProdRes] = await Promise.all([
          api.get('/int/produtos', { params: { offset: 0, limit: 10000 } }).catch(() => ({ data: [] })),
          api.get('/get/produtos', { params: { offset: 0, limit: 10000 } }).catch(() => ({ data: [] })),
        ])
        const intProds = prodRes.data?.data || prodRes.data || []
        const getProds = getProdRes.data?.data || getProdRes.data || []
        const produtos = [
          ...(Array.isArray(intProds) ? intProds : []),
          ...(Array.isArray(getProds) ? getProds : []),
        ]

        const marcasUnicas = Array.from(
          new Set(produtos.map((p: any) => p.marca || p.vinc_marca || p.ds_marca).filter(Boolean)),
        ) as string[]

        const marcasPermitidas = userVinculoMarca
          ? userVinculoMarca.split(',').map((s) => s.trim().toUpperCase()).filter(Boolean)
          : []

        const marcasFiltradas = marcasPermitidas.length > 0
          ? marcasUnicas.filter((m) => marcasPermitidas.includes(m.toUpperCase()))
          : marcasUnicas

        if (marcasPermitidas.length > 0) {
          setMarcasList(marcasFiltradas.length > 0 ? marcasFiltradas : marcasPermitidas)
          if (marcasFiltradas.length === 1) {
            setMarca(marcasFiltradas[0])
          }
        } else {
          setMarcasList(marcasUnicas)
        }
        const categoriasUnicas = Array.from(
          new Set(
            produtos
              .map((p: any) => p.categoria || p.familia || p.ds_categoria || p.ds_familia)
              .filter(Boolean),
          ),
        )
        setCategoriasList(categoriasUnicas)

        const usersRes = await api.get('/users')
        const usersList = usersRes.data?.data || usersRes.data || []
        const apenasGestores = usersList.filter((u: any) => (u.role || '').toString().toLowerCase() === 'gestor')
        setGestoresList(apenasGestores)
      } catch (error) {
        console.error(error)
      }
    }
    initData()
  }, [user, setMarca])

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (calendarRef.current && !calendarRef.current.contains(event.target as Node)) {
        setShowCalendar(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const years = useMemo(() => {
    const current = new Date().getFullYear()
    return Array.from({ length: 9 }, (_, i) => current - i)
  }, [])

  const handleDateChange = (value: any) => {
    if (Array.isArray(value)) {
      setStartDate(value[0])
      setEndDate(value[1])
      if (value[0] && value[1]) setMonth(-1)
    }
  }

  const clearCalendar = () => {
    setStartDate(null)
    setEndDate(null)
    setShowCalendar(false)
  }

  const handleOperacaoChange = (newOp: string) => {
    setOperacao(newOp)
    if (newOp) {
      const matching = distributors.filter((d: any) => {
        const reg = (d.regional || d.operacao || d.regiao || '').trim().toLowerCase()
        const matchesGestor = !gestor || (d.gestor_id && String(d.gestor_id) === String(gestor))
        return reg === newOp.trim().toLowerCase() && matchesGestor
      })
      const ids = matching.map((d: any) => d.id || d._id).filter(Boolean)
      selectAllDistributors(ids)
    } else {
      clearDistributors()
    }
  }

  const handleGestorChange = (newGestor: string) => {
    setGestor(newGestor)
    if (newGestor) {
      const matching = distributors.filter((d: any) => {
        const matchesGestor = d.gestor_id && String(d.gestor_id) === String(newGestor)
        const reg = (d.regional || d.operacao || d.regiao || '').trim().toLowerCase()
        const matchesOp = !operacao || reg === operacao.trim().toLowerCase()
        return matchesGestor && matchesOp
      })
      const ids = matching.map((d: any) => d.id || d._id).filter(Boolean)
      selectAllDistributors(ids)
    } else if (!operacao) {
      clearDistributors()
    } else {
      const matching = distributors.filter((d: any) => {
        const reg = (d.regional || d.operacao || d.regiao || '').trim().toLowerCase()
        return reg === operacao.trim().toLowerCase()
      })
      const ids = matching.map((d: any) => d.id || d._id).filter(Boolean)
      selectAllDistributors(ids)
    }
  }

  const selectStyle: React.CSSProperties = {
    padding: '8px 10px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontWeight: 'bold',
    width: '100%',
    fontFamily: 'Montserrat',
    backgroundColor: '#ffffff',
    color: '#000000',
    fontSize: '12px',
    minHeight: '36px',
  }

  return (
    <>
      <style>{`
  select {
    color: #000000 !important;
    background-color: #ffffff !important;
  }
  select option {
    color: #000000 !important;
    background-color: #ffffff !important;
  }
  .react-calendar {
    width: 100% !important;
    max-width: 350px;
    border: none !important;
    font-family: 'Montserrat', sans-serif;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  }

  .react-calendar__month-view__days__day--neighboringMonth {
   color: #ccc !important;
  }

  .react-calendar__month-view__days__day {
    color: #000 !important;
    font-weight: bold !important;
  }
  .react-calendar__navigation button {
    font-weight: bold;
    color: #001D53;
    border-radius: 8px;
  }

  .react-calendar__month-view__weekdays {
    font-weight: bold;
    font-size: 11px;
    text-transform: uppercase;
    color: #001D53;
  }

  .react-calendar__tile {
    color: #000;
    font-size: 12px;
    padding: 8px 0px !important;
    border-radius: 8px;
  }

  .react-calendar__tile--range {
    background: #e6f0ff !important;
    color: #001D53 !important;
  }

  .react-calendar__tile--rangeStart,
  .react-calendar__tile--rangeEnd,
  .react-calendar__tile--active {
    background: #001D53 !important;
    color: white !important;
  }

  .calendar-popover {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    right: 0;
    z-index: 999999;
    background-color: #ffffff;
    box-shadow: 0 10px 30px rgba(0,0,0,0.6);
    border: 1px solid rgba(0, 29, 83, 0.15);
    border-radius: 12px;
    padding: 12px;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    .calendar-popover {
      left: 50%;
      bottom: calc(100% + 8px);
      top: auto;
      transform: translateX(-50%);
      width: 90vw;
      max-width: 95vw;
    }

    .react-calendar {
      max-width: 95vw;
      box-shadow: 0 10px 30px rgba(0,0,0,0.5);
    }

    .react-calendar__tile {
      font-size: 11px;
      padding: 6px 0px !important;
    }

    .react-calendar__navigation button {
      font-size: 13px;
    }
  }

  /* ROLAGEM SUAVE E MODERNA */
  .body.no-print {
    scrollbar-width: thin;
    scrollbar-color: rgba(166, 193, 11, 0.4) rgba(0, 0, 0, 0.2);
  }
  .body.no-print::-webkit-scrollbar {
    width: 6px;
  }
  .body.no-print::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
  .body.no-print::-webkit-scrollbar-thumb {
    background: rgba(166, 193, 11, 0.4);
    border-radius: 4px;
  }
  .body.no-print::-webkit-scrollbar-thumb:hover {
    background: #a6c10b;
  }

  @media (max-width: 480px) {
    .body.no-print {
      grid-template-columns: 1fr !important;
      gap: 10px !important;
      padding: 12px 14px 20px 14px !important;
    }
  }
`}</style>

      <div className='header'>
        <h2>Filtrar</h2>
        <button
          onClick={() => closeModal()}
          type='button'
          style={{
            background: 'transparent',
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: 26,
            border: 'none',
            color: '#ffffff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999999999,
          }}
        >
          <IoCloseCircleSharp />
        </button>
      </div>

      <div
        className='body no-print'
        style={{
          fontFamily: "'Montserrat', sans-serif",
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '8px 12px',
          padding: '14px 18px 20px 18px',
          alignContent: 'start',
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          width: '100%',
        }}
      >
        <ItemContainerStyle style={{ gridColumn: '1 / -1' }}>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>TIPO DE VISÃO</span>
          <select
            style={selectStyle}
            value={visao}
            onChange={(e) => setVisao(e.target.value as any)}
          >
            {isMarketAnalysis ? (
              <>
                <option value='semanas'>Semanas (S1 - S4 Contagem Reversa)</option>
                <option value='trimestre'>Trimestres (Q1 - Q4)</option>
                <option value='ano'>Período Mensal / Anual</option>
              </>
            ) : (
              <>
                <option value='semanas'>Semanas (S1 - S4 Contagem Reversa)</option>
                <option value='trimestre'>Trimestre vs Trimestre (Q1-Q4)</option>
                <option value='mes'>Mês vs Mês (Comparativo Mensal)</option>
                <option value='ano'>Ano vs Ano (12 meses)</option>
              </>
            )}
          </select>
        </ItemContainerStyle>

        {/* MODO ANO / PERÍODO ANUAL */}
        {visao === 'ano' && (
          <>
            <ItemContainerStyle style={{ gridColumn: isMarketAnalysis ? '1 / -1' : undefined }}>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>
                {isMarketAnalysis ? 'ANO' : 'ANO BASE (ATUAL)'}
              </span>
              <select
                style={selectStyle}
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
              >
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            {!isMarketAnalysis && (
              <ItemContainerStyle>
                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>ANO DE COMPARAÇÃO</span>
                <select
                  style={selectStyle}
                  value={compareYear}
                  onChange={(e) => setCompareYear(Number(e.target.value))}
                >
                  {years
                    .filter((y) => y < year)
                    .map((y) => (
                      <option key={y} value={y}>
                        {y}
                      </option>
                    ))}
                </select>
              </ItemContainerStyle>
            )}

            {!isMarketAnalysis && (
              <ItemContainerStyle style={{ gridColumn: '1 / -1' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                  }}
                >
                  <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>
                    MESES A EXIBIR ({tempMesesAno.length}/12)
                  </span>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <button
                      type='button'
                      onClick={selectAllTempMesesAno}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#a6c10b',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                      }}
                    >
                      SELECIONAR TODOS
                    </button>
                    <span style={{ color: 'rgba(255, 255, 255, 0.3)', fontSize: '11px' }}>|</span>
                    <button
                      type='button'
                      onClick={clearTempMesesAno}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#ff7875',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                      }}
                    >
                      LIMPAR
                    </button>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '6px' }}>
                  {monthNames.map((m, idx) => {
                    const isSelected = tempMesesAno.includes(idx)
                    return (
                      <button
                        key={idx}
                        type='button'
                        onClick={() => toggleTempMesAno(idx)}
                        style={{
                          padding: '7px 4px',
                          borderRadius: '6px',
                          border: isSelected
                            ? '1px solid #a6c10b'
                            : '1px solid rgba(255, 255, 255, 0.1)',
                          background: isSelected
                            ? 'rgba(166, 193, 11, 0.2)'
                            : 'rgba(255, 255, 255, 0.05)',
                          color: isSelected ? '#a6c10b' : '#ffffff',
                          fontWeight: isSelected ? 'bold' : 'normal',
                          fontSize: '11px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '5px',
                          transition: 'all 0.2s ease',
                        }}
                      >
                        {isSelected && <FaCheck size={9} />}
                        {m.slice(0, 3).toUpperCase()}
                      </button>
                    )
                  })}
                </div>
              </ItemContainerStyle>
            )}

            {isMarketAnalysis && (
              <>
                <ItemContainerStyle>
                  <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>MÊS INICIAL</span>
                  <select
                    style={selectStyle}
                    value={month === -1 ? new Date().getMonth() : month}
                    onChange={(e) => setMonth(Number(e.target.value))}
                  >
                    {monthNames.map((m, idx) => (
                      <option key={idx} value={idx}>
                        {m.toUpperCase()}
                      </option>
                    ))}
                  </select>
                </ItemContainerStyle>

                <ItemContainerStyle>
                  <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>MÊS FINAL</span>
                  <select
                    style={selectStyle}
                    value={endMonth === -1 ? (month === -1 ? new Date().getMonth() : month) : endMonth}
                    onChange={(e) => setEndMonth(Number(e.target.value))}
                  >
                    {monthNames.map((m, idx) => (
                      <option key={idx} value={idx}>
                        {m.toUpperCase()}
                      </option>
                    ))}
                  </select>
                </ItemContainerStyle>
              </>
            )}
          </>
        )}

        {/* MODO TRIMESTRE */}
        {visao === 'trimestre' && (
          <>
            <ItemContainerStyle style={{ gridColumn: isMarketAnalysis ? '1 / -1' : undefined }}>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>
                {isMarketAnalysis ? 'ANO' : 'ANO BASE (ATUAL)'}
              </span>
              <select
                style={selectStyle}
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
              >
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            {!isMarketAnalysis && (
              <ItemContainerStyle>
                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>ANO DE COMPARAÇÃO</span>
                <select
                  style={selectStyle}
                  value={compareYear}
                  onChange={(e) => setCompareYear(Number(e.target.value))}
                >
                  {years
                    .filter((y) => y < year)
                    .map((y) => (
                      <option key={y} value={y}>
                        {y}
                      </option>
                    ))}
                </select>
              </ItemContainerStyle>
            )}

            <ItemContainerStyle style={{ gridColumn: '1 / -1' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>
                  TRIMESTRES (SELEÇÃO MÚLTIPLA)
                </span>
                <button
                  type='button'
                  onClick={selectAllTrimestres}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#a6c10b',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  SELECIONAR TODOS
                </button>
              </div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {[
                  { key: 'todos', label: 'Todos os Trimestres (Q1 - Q4)' },
                  { key: 'Q1', label: '1º Trimestre (Q1: Jan - Mar)' },
                  { key: 'Q2', label: '2º Trimestre (Q2: Abr - Jun)' },
                  { key: 'Q3', label: '3º Trimestre (Q3: Jul - Set)' },
                  { key: 'Q4', label: '4º Trimestre (Q4: Out - Dez)' },
                ].map((item) => {
                  const isSelected =
                    item.key === 'todos'
                      ? trimestres.length === 0
                      : trimestres.includes(item.key)
                  return (
                    <button
                      key={item.key}
                      type='button'
                      onClick={() => toggleTrimestre(item.key)}
                      style={{
                        flex: item.key === 'todos' ? '1 1 100%' : '1 1 calc(50% - 6px)',
                        padding: '8px 10px',
                        borderRadius: '6px',
                        border: isSelected ? '1px solid #a6c10b' : '1px solid rgba(255, 255, 255, 0.1)',
                        background: isSelected ? 'rgba(166, 193, 11, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                        color: isSelected ? '#a6c10b' : '#ffffff',
                        fontWeight: isSelected ? 'bold' : 'normal',
                        fontSize: '11px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      {isSelected && <FaCheck size={10} />}
                      {item.label}
                    </button>
                  )
                })}
              </div>
            </ItemContainerStyle>
          </>
        )}

        {/* MODO MÊS VS MÊS (APENAS FASEAMENTO) */}
        {visao === 'mes' && !isMarketAnalysis && (
          <>
            <ItemContainerStyle>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>ANO BASE</span>
              <select
                style={selectStyle}
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
              >
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            <ItemContainerStyle>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>MÊS BASE</span>
              <select
                style={selectStyle}
                value={month === -1 ? new Date().getMonth() : month}
                onChange={(e) => setMonth(Number(e.target.value))}
              >
                {monthNames.map((m, idx) => (
                  <option key={idx} value={idx}>
                    {m.toUpperCase()}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            <ItemContainerStyle>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#69c0ff' }}>ANO DE COMPARAÇÃO</span>
              <select
                style={selectStyle}
                value={compareYear}
                onChange={(e) => setCompareYear(Number(e.target.value))}
              >
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            <ItemContainerStyle>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#69c0ff' }}>MÊS DE COMPARAÇÃO</span>
              <select
                style={selectStyle}
                value={compareMonth}
                onChange={(e) => setCompareMonth(Number(e.target.value))}
              >
                {monthNames.map((m, idx) => (
                  <option key={idx} value={idx}>
                    {m.toUpperCase()}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>
          </>
        )}

        {/* MODO SEMANAS S1-S4 */}
        {visao === 'semanas' && (
          <>
            <ItemContainerStyle style={{ gridColumn: '1 / -1' }}>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>ANO</span>
              <select
                style={selectStyle}
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
              >
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            <ItemContainerStyle>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>MÊS INICIAL</span>
              <select
                style={selectStyle}
                value={month === -1 ? new Date().getMonth() : month}
                onChange={(e) => setMonth(Number(e.target.value))}
              >
                {monthNames.map((m, idx) => (
                  <option key={idx} value={idx}>
                    {m.toUpperCase()}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            <ItemContainerStyle>
              <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#a6c10b' }}>MÊS FINAL</span>
              <select
                style={selectStyle}
                value={endMonth === -1 ? (month === -1 ? new Date().getMonth() : month) : endMonth}
                onChange={(e) => setEndMonth(Number(e.target.value))}
              >
                {monthNames.map((m, idx) => (
                  <option key={idx} value={idx}>
                    {m.toUpperCase()}
                  </option>
                ))}
              </select>
            </ItemContainerStyle>

            <ItemContainerStyle style={{ gridColumn: '1 / -1' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>
                  SEMANAS (SELEÇÃO MÚLTIPLA)
                </span>
                <button
                  type='button'
                  onClick={selectAllSemanas}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#a6c10b',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  SELECIONAR TODAS
                </button>
              </div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                {[
                  { key: 'todas', label: 'Todas as Semanas (S1 - S4)' },
                  { key: 'S1', label: 'Semana 1 (S1)' },
                  { key: 'S2', label: 'Semana 2 (S2)' },
                  { key: 'S3', label: 'Semana 3 (S3)' },
                  { key: 'S4', label: 'Semana 4 (S4)' },
                ].map((item) => {
                  const isSelected =
                    item.key === 'todas'
                      ? semanas.length === 0
                      : semanas.includes(item.key)
                  return (
                    <button
                      key={item.key}
                      type='button'
                      onClick={() => toggleSemana(item.key)}
                      style={{
                        flex: item.key === 'todas' ? '1 1 100%' : '1 1 calc(25% - 6px)',
                        padding: '8px 10px',
                        borderRadius: '6px',
                        border: isSelected ? '1px solid #a6c10b' : '1px solid rgba(255, 255, 255, 0.1)',
                        background: isSelected ? 'rgba(166, 193, 11, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                        color: isSelected ? '#a6c10b' : '#ffffff',
                        fontWeight: isSelected ? 'bold' : 'normal',
                        fontSize: '11px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      {isSelected && <FaCheck size={10} />}
                      {item.label}
                    </button>
                  )
                })}
              </div>
            </ItemContainerStyle>
          </>
        )}

        <ItemContainerStyle>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>OPERAÇÃO</span>
          <select
            style={selectStyle}
            value={operacao || ''}
            onChange={(e) => handleOperacaoChange(e.target.value)}
          >
            <option value=''>Todos</option>
            {operacoesList.map((op, idx) => (
              <option key={idx} value={op}>
                {op}
              </option>
            ))}
          </select>
        </ItemContainerStyle>

        <ItemContainerStyle>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>UF / ESTADO</span>
          <select
            style={selectStyle}
            value={uf || ''}
            onChange={(e) => setUf(e.target.value)}
          >
            <option value=''>Todos os Estados</option>
            {ufsList.map((estado) => (
              <option key={estado} value={estado}>
                {estado}
              </option>
            ))}
          </select>
        </ItemContainerStyle>

        <ItemContainerStyle>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>GESTOR</span>
          <select
            style={selectStyle}
            value={gestor || ''}
            onChange={(e) => handleGestorChange(e.target.value)}
          >
            <option value=''>Todos</option>
            {gestoresList.map((g: any) => {
              const gId = g.id || g._id
              const gName = g.fantasy_name || g.name || g.nome || g.username || g.name_user || g.email || `Gestor (${gId})`
              return (
                <option key={gId} value={gId}>
                  {gName}
                </option>
              )
            })}
          </select>
        </ItemContainerStyle>

        <ItemContainerStyle>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>MARCAS GSA</span>
          <select
            style={selectStyle}
            value={marca || ''}
            onChange={(e) => setMarca(e.target.value)}
            disabled={!!userMarca}
          >
            {!userMarca && <option value=''>Todos</option>}
            {marcasList.map((m, idx) => (
              <option key={idx} value={m}>
                {m}
              </option>
            ))}
          </select>
        </ItemContainerStyle>

        <ItemContainerStyle style={{ gridColumn: '1 / -1' }}>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>CATEGORIA</span>
          <select
            style={selectStyle}
            value={categoria || ''}
            onChange={(e) => setCategoria(e.target.value)}
          >
            <option value=''>Todos</option>
            {categoriasList.map((cat, idx) => (
              <option key={idx} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </ItemContainerStyle>

        <ItemContainerStyle style={{ gridColumn: '1 / -1', position: 'relative' }} ref={calendarRef}>
          <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>
            PERÍODO ESPECÍFICO
          </span>
          <div
            onClick={() => setShowCalendar(!showCalendar)}
            style={{
              padding: '8px 10px',
              borderRadius: '8px',
              border: startDate ? '2px solid #001D53' : '1px solid #ccc',
              backgroundColor: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '12px',
              minHeight: '36px',
            }}
          >
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {startDate && endDate
                ? `${startDate.toLocaleDateString('pt-BR')} - ${endDate.toLocaleDateString('pt-BR')}`
                : 'Selecionar Datas'}
            </span>
            <CiCalendar size={18} color='#001D53' />
          </div>

          {showCalendar && (
            <div className='calendar-popover'>
              <Calendar
                onChange={handleDateChange}
                selectRange={true}
                value={startDate && endDate ? [startDate, endDate] : null}
                locale='pt-BR'
              />
              <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                <button
                  onClick={clearCalendar}
                  style={{
                    flex: 1,
                    padding: '8px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    cursor: 'pointer',
                    color: '#001D53',
                    backgroundColor: '#f5f5f5',
                    fontWeight: 'bold',
                  }}
                >
                  LIMPAR
                </button>
                <button
                  onClick={() => setShowCalendar(false)}
                  style={{
                    flex: 1,
                    padding: '8px',
                    borderRadius: '5px',
                    border: 'none',
                    cursor: 'pointer',
                    backgroundColor: '#001D53',
                    color: '#fff',
                    fontWeight: 'bold',
                  }}
                >
                  APLICAR
                </button>
              </div>
            </div>
          )}
        </ItemContainerStyle>

        <ItemContainerStyle style={{ gridColumn: '1 / -1' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '6px',
            }}
          >
            <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#ffffff' }}>
              DISTRIBUIDORES ({distributorIds.length === 0 ? 'TODOS' : `${distributorIds.length} selecionado(s)`})
            </span>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                type='button'
                onClick={() => selectAllDistributors(filteredDistributorsList.map((d: any) => d.id || d._id).filter(Boolean))}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#a6c10b',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                Selecionar Todos
              </button>
              <span style={{ color: '#666', fontSize: '11px' }}>|</span>
              <button
                type='button'
                onClick={clearDistributors}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#ff4d4f',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                Limpar
              </button>
            </div>
          </div>

          {/* Busca de Distribuidor */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#ffffff',
              borderRadius: '8px',
              padding: '6px 10px',
              marginBottom: '8px',
              border: '1px solid #ccc',
            }}
          >
            <FaSearch style={{ color: '#888', marginRight: '6px', fontSize: '12px' }} />
            <input
              type='text'
              placeholder='Buscar distribuidor...'
              value={distSearch}
              onChange={(e) => setDistSearch(e.target.value)}
              style={{
                border: 'none',
                outline: 'none',
                width: '100%',
                fontSize: '12px',
                fontFamily: 'Montserrat, sans-serif',
              }}
            />
          </div>

          {/* Lista com Checkboxes */}
          <div
            style={{
              maxHeight: '130px',
              overflowY: 'auto',
              backgroundColor: 'rgba(0, 20, 60, 0.6)',
              borderRadius: '8px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              padding: '4px',
            }}
          >
            {filteredDistributorsList.length === 0 ? (
              <div style={{ padding: '10px', textAlign: 'center', color: '#8e9aaf', fontSize: '12px' }}>
                Nenhum distribuidor encontrado
              </div>
            ) : (
              filteredDistributorsList.map((d: any) => {
                const id = d.id || d._id
                const name = d.fantasy_name || d.name || d.nome || d.razao_social || `Distribuidor ${id}`
                const isSelected = distributorIds.some((selectedId) => String(selectedId) === String(id))

                return (
                  <div
                    key={id}
                    className='dist-checkbox-item'
                    onClick={() => toggleDistributor(id)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '8px',
                      padding: '5px 8px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s',
                      backgroundColor: isSelected ? 'rgba(166, 193, 11, 0.2)' : 'transparent',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden', flex: 1 }}>
                      <div
                        style={{
                          width: '15px',
                          height: '15px',
                          borderRadius: '4px',
                          border: isSelected ? '2px solid #a6c10b' : '1px solid #8e9aaf',
                          backgroundColor: isSelected ? '#a6c10b' : 'transparent',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                        }}
                      >
                        {isSelected && <FaCheck size={9} color='#001D53' />}
                      </div>
                      <span
                        style={{
                          color: isSelected ? '#ffffff' : '#e0e0e0',
                          fontSize: '11px',
                          fontWeight: isSelected ? 'bold' : 'normal',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {name}
                      </span>
                    </div>

                    <button
                      type='button'
                      title={`Filtrar apenas por ${name}`}
                      onClick={(e) => {
                        e.stopPropagation()
                        setDistributor(null)
                        setDistributorIds([id])
                      }}
                      style={{
                        background:
                          isSelected && distributorIds.length === 1
                            ? '#a6c10b'
                            : 'rgba(255, 255, 255, 0.08)',
                        color:
                          isSelected && distributorIds.length === 1 ? '#001D53' : '#a6c10b',
                        border: 'none',
                        borderRadius: '4px',
                        fontSize: '9px',
                        fontWeight: 'bold',
                        padding: '2px 6px',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      Apenas este
                    </button>
                  </div>
                )
              })
            )}
          </div>
        {/* FIM DO BLOCO DE DISTRIBUIDORES */}
        </ItemContainerStyle>
      </div>

      {/* RODAPÉ FIXO COM BOTÃO APLICAR FILTROS (SEMPRE VISÍVEL EM QUALQUER RESOLUÇÃO) */}
      <div
        className='filter-footer'
        style={{
          flexShrink: 0,
          width: '100%',
          padding: '12px 18px',
          backgroundColor: 'rgba(0, 20, 60, 0.98)',
          backdropFilter: 'blur(8px)',
          borderTop: '1px solid rgba(255, 255, 255, 0.12)',
          boxShadow: '0 -4px 15px rgba(0, 0, 0, 0.35)',
          boxSizing: 'border-box',
          zIndex: 10,
        }}
      >
        <button
          type='button'
          onClick={() => {
            setMesesAno(tempMesesAno)
            closeModal()
          }}
          style={{
            width: '100%',
            height: '42px',
            backgroundColor: '#a6c10b',
            color: '#001D53',
            border: 'none',
            borderRadius: '8px',
            fontWeight: 'bold',
            fontSize: '13px',
            cursor: 'pointer',
            fontFamily: 'Montserrat, sans-serif',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(1.1)')}
          onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(1.0)')}
        >
          Aplicar Filtros
        </button>
      </div>
    </>
  )
}
